import { TRequestSkill, TSkills } from "./types";
import { appSkillsApi } from "../../config/apiConfig";
import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";

export const getSkills = (): Promise<TSkills> => {
  return appSkillsApi
    .get("/skills", {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getSkill = (name: string): Promise<TSkills> => {
  return appSkillsApi
    .get(`/skill/${name}`, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const updateSkill = (
  name: string,
  postObj: TRequestSkill,
): Promise<TSkills> => {
  return appSkillsApi
    .put(`/skill/${name}`, postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};
